<template>
  <div class="box2-page">
    <div class="fcp-title">为什么要认证帆软FCP</div>
    <div class="fcp-stitle stit-1">
      <span>FCP认证的4大必要性</span>
    </div>
    <ul class="info-list">
      <li v-for="(item, index) in list" :key="index" >
        <div class="top" @click="open(item)">
          <img :src="item.icon" alt="">
          <span>{{ item.title }}</span>
          <div class="open-btn" :class="{active: item.flag}"></div>
        </div>
        <div class="bottom" v-show="item.flag">
          <p v-for="(v1, i1) in item.info" :key="i1">{{ v1 }}</p>
        </div>
      </li>
    </ul>
    <div class="fcp-stitle stit-2">
      <span>帆软强大的实力</span>
    </div>
    <div class="fcp-text">专注商业智能和数据分析领域，致力于提供一站式<br/>商业智能解决方案</div>
    <div class="text-list-mask">
      <div class="text-list">
        <div>国内BI、零代码<br/>市占率双第一</div>
        <div>超26000+家<br/>大中型企业之选</div>
        <div>800+企业<br/>数据化应用场景</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      list: [
        {
          icon: require('../../../assets/coursePage/fcp/box2/icon-01.png'),
          title: '专业能力的有效验证',
          info: [
            'FCP（Fanruan Certified Professional - Reporting Delivery Engineer）是针对于BI领域尤其是报表领域的工程师开展的认证，通过该认证意味着您可以承担报表项目的交付工作，除报表开发外还具备一定的数据库、部署集成、数据处理以及项目管理能力，是运用FineReport、Kettle等产品进行报表项目落地时的必备认证，它是充分证明自我专业知识和技术能力的有效佐证。'
          ],
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/fcp/box2/icon-02.png'),
          title: '获得行业权威认可',
          info: [
            '帆软在商业智能和数据分析领域处于行业领先位置，在国内大数据分析和商业智能领域中具有专业水准，且组织规模大、服务范围广、企业客户数量多，其凭借多年行业经验推出的认证具备一定的权威性。'
          ],
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/fcp/box2/icon-03.png'),
          title: '获取更高的薪酬',
          info: [
            '通过认证是你数据接入、数据分析、数据应用、数据处理等能力的直观证明，持证者可更受企业的认可和青睐，让自己脱颖而出，相应的也可获得高薪回报。'
          ],
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/fcp/box2/icon-04.png'),
          title: '业务价值不容小觑',
          info: [
            '办公实现自动化：绘制图表、数据分析可实现自动化办公模式，有效提效80%，极大缓解工作效率慢的问题，让分析更高效。',
            '业务指标可视化：面向业务场景提供采集、分析、展现、决策的完整数据应用，可视化展示，让数据更直观。',
            '辅助性决策：企业营收分析、财务成本管控等高频场景，关键数据一屏掌控，实现业务统一指挥决策，资源及时调度，让决策更智能。'
          ],
          flag: false,
        }
      ]
    }
  },
  methods:{
    open(item){
      this.list.forEach(val => {
        if(item.title === val.title){
          val.flag = !val.flag
        }else{
          val.flag = false
        }
      });
      
    }
  }
}
</script>

<style lang="scss" scoped>
.box2-page {
  background-image: url(../../../assets/coursePage/fcp/box2/box2-bg.png);
  background-size: cover;
  padding: 80px 32px 88px;
  .stit-1{
    &:after{
      width: 312px;
    }
  }
  .stit-2{
    margin-top: 80px;
    &:after{
      width: 228px;
    }
  }
  .info-list{
    margin-top: 50px;
    li{
      background: linear-gradient(226deg, #EDF9FE 0%, #FFFFFF 49%, #FFFFFF 66%, rgba(205,235,253,0.49) 100%);
      border: 2px solid rgba(222, 234, 255, 1);
      border-radius: 16px;
      margin-bottom: 24px;
      .top{
        padding: 24px 32px 24px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img{
          width: 64px;
          height: 64px;
        }
        span{
          flex: 1;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #24375C;
          line-height: 64px;
          padding-left: 32px;
        }
        .open-btn{
          width: 32px;
          height: 32px;
          background: url(../../../assets/coursePage/fcp/box2/icon-down.png);
          background-size: 100% 100%;
          &.active{
            transform: rotate(180deg);
          }
        }
      }
      .bottom{
        padding: 0 40px 40px;
        p{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #425A7C;
          line-height: 44px;
          margin-bottom: 24px;
        }
        p:last-child{
          margin-bottom:0;
        }
      }
    }
  }

  .text-list-mask{
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 136px;
    margin-left: -32px;
    width: 750px;
    .text-list{
      max-width: 828px;
      height: 176px;
      display: flex;
      padding: 0 32px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      >div{
        width: 260px;
        min-width: 260px;
        height: 136px;
        padding: 24px 0 24px 32px;
        background: url(../../../assets/coursePage/fcp/box2/card-bg.png);
        background-size: 260px 136px;
        background-repeat: no-repeat;
        margin-right: 24px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #24375C;
        line-height: 44px;
        box-sizing: border-box;
        &:last-child{
          margin: 0;
        }
      }
    }
  }
}

</style>